export const phoneNumberValidationRegex = /[2-9]\d{7}/i;
export const guidValidationRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const wholeNumbersRegex = /^\d+$/;
export const decimalNumberValidationRegex = /^-?\d+(?:[.,]\d*)?$/;
export const companyRegistrationNumberRegex = /^\d{8}$/;
